<template>
  <!-- 封面 -->
  <div class="page cover" :style="{'background-position': '50% -' + bgTop + 'rem'}" @click="nextPage">
    <div class="content" :style="{top: contentTop + 'rem'}">
      <div class="title"></div>
      <div class="logo-box">
        <div v-if="isTx" class="logo"></div>
        <div v-if="isTx" class="logo-tx"></div>
        <div v-else class="logo-china"></div>
      </div>

      <div class="anim1"></div>
      <div class="anim2 rotatel"></div>
      <div class="anim3 rotater"></div>
      <div class="anim45 rotate45">
        <div class="anim4"></div>
        <div class="anim5"></div>
      </div>
      <div class="anim6"></div>
      <div class="anim7">
        <div class="anim7-1 fade1"></div>
        <div class="anim7-2 fade2"></div>
        <div class="anim7-3 fade3"></div>
      </div>
      <div class="anim8"></div>
      <div class="anim9 rotatel"></div>
      <div class="anim10 rotater"></div>
      <div class="anim11"></div>
      <div class="anim12"></div>

      <div class="swiper-container" id="swiper1">
        <div class="swiper-wrapper">
          <div class="swiper-slide">
            <div class="swiper-text" style="opacity: 0">后浪们<br />拼的是想法</div>
          </div>
          <div class="swiper-slide">
            <div class="swiper-text">我们年轻人<br />拼的是事业</div>
          </div>
          <div class="swiper-slide">
            <div class="swiper-text">人到中年了<br />拼的是心态</div>
          </div>
          <div class="swiper-slide">
            <div class="swiper-text">咱们老年人啊<br />拼的是健康</div>
          </div>
        </div>
      </div>

      <div class="swiper-container" id="swiper2">
        <div class="swiper-wrapper">
          <div class="swiper-slide">
            <div class="swiper-text" style="opacity: 0">拼出精气神，干出新气象</div>
          </div>
          <div class="swiper-slide">
            <div class="swiper-text">做产品，拼的是质量</div>
          </div>
          <div class="swiper-slide">
            <div class="swiper-text">招商引资，拼政策更要拼环境</div>
          </div>
        </div>
      </div>

      <div class="swiper-container" id="swiper3">
        <div class="swiper-wrapper">
          <div class="swiper-slide">
            <div class="swiper-text" style="opacity: 0">中小企业想要发展得好<br />还得拼创新能力</div>
          </div>
          <div class="swiper-slide">
            <div class="swiper-text">下电影比下饺子都快<br />5G时代拼的就是速度</div>
          </div>
          <div class="swiper-slide">
            <div class="swiper-text">绿水青山要留给子孙后代<br />拼的是绿色发展</div>
          </div>
        </div>
      </div>

      <div class="swiper-container" id="swiper4">
        <div class="swiper-wrapper">
          <div class="swiper-slide">
            <div class="swiper-text" style="opacity: 0">拼服务、拼效益、拼活力、拼士气……</div>
          </div>
          <div class="swiper-slide">
            <div class="swiper-text">不管是谁家的偶像 都要拼作品质量</div>
          </div>
          <div class="swiper-slide">
            <div class="swiper-text">未来，拼的是教育，拼的是人才</div>
          </div>
        </div>
      </div>

      <div class="finger-box">
        <!-- 手指动效 -->
        <div class="finger"></div>

        <div class="btn"></div>
      </div>
    </div>

    <!-- 拼字的碎片 -->
    <div class="pieces-pin" :style="{top: piecesTop + 'rem'}">
      <div v-for="(item, index) in titleText" :key="index" class="piece" :style="{'background-color': item.color, 'clip-path': `polygon(${item.point1.x}px ${item.point1.y}px, ${item.point2.x}px ${item.point2.y}px, ${item.point3.x}px ${item.point3.y}px)`, '-webkit-clip-path': `polygon(${item.point1.x}px ${item.point1.y}px, ${item.point2.x}px ${item.point2.y}px, ${item.point3.x}px ${item.point3.y}px)`}"></div>
    </div>
  </div>
</template>

<script>
// import HelloWorld from './components/HelloWorld.vue'
function formateData (source, type) {
  const target = []
  let size = window.innerWidth / 750 / 2

  source.split('\n').forEach(line => {
    if (!line || line.trim().length <= 0) return false
    line = line.replace(/^\s*\d+\.?\s?/ig, '')
    let color = line.match(/^#\w{6}/ig)[0]
  
    const points = line.replace(/^#\w{6}\s+/ig, '').replace(/\s+/ig, '-').split('-')

    const buchangX = type === 'result' ? 150 : 0
    const buchangY = type === 'result' ? 900 : 0
  
    let point1 = {
      x: (points[0].split(',')[0] - 0 + buchangX) * size,
      y: (points[0].split(',')[1] - 0 + buchangY) * size
    }
    let point2 = {
      x: (points[1].split(',')[0] - 0 + buchangX) * size,
      y: (points[1].split(',')[1] - 0 + buchangY) * size
    }
    let point3 = {
      x: (points[2].split(',')[0] - 0 + buchangX) * size,
      y: (points[2].split(',')[1] - 0 + buchangY) * size
    }

    if (type === 'default') {
      point1.x = 2 * point1.x
      point1.y = 2 * point1.y
      point2.x = 2 * point2.x
      point2.y = 2 * point2.y
      point3.x = 2 * point3.x
      point3.y = 2 * point3.y
    }
  
    target.push({
      color,
      point1,
      point2,
      point3
    })
  })

  return target
}

// 标题里的拼字
const titleText = {
  default: formateData(`
  1.#000000    0,0     0,0     0,0
  2.#000000    187,0     187,0     187,0
  3.#000000    374,0     374,0     374,0
  4.#000000    561,0     561,0     561,0
  5.#000000    750,0     750,0     750,0
  6.#000000    750,232     750,232     750,232
  7.#000000    750,464     750,464     750,464
  8.#000000    750,696     750,696     750,696
  8.#000000    750,928     750,928     750,928
  10.#000000    750,1160     750,1160     750,1160
  11.#000000    750,1392     750,1392     750,1392
  12.#000000    750,1624     750,1624     750,1624
  13.#000000    561,1624     561,1624     561,1624
  14.#000000    374,1624     374,1624     374,1624
  15.#000000    187,1624     187,1624     187,1624
  16.#000000    0,1624     0,1624     0,1624
  17.#000000    0,1392     0,1392     0,1392
  18.#000000    0,1160     0,1160     0,1160
  19.#000000    0,928     0,928     0,928
  20.#000000    0,696     0,696     0,696
  21.#000000    0,464     0,464     0,464
  22.#000000    0,232     0,232     0,232
  `, 'default'),
  // 22.#000000    260,600     260,600     260,600
  result: formateData(`
  1.#FFDE65    265,535       90,622        90,566
  2.#F29574    265,535       265,590       90,622

  3.#FBE9A7    219,487       212,522       162,496
  4.#FFDE65    212,522       162,790       162,496
  5.#F29574    219,487       219,851       162,790
  6.#F29574    219,851       158,851       162,790
  7.#FFDE65    158,851       162,790       136,790

  8.#FFDE65    247,646       58,748        58,700
  8.#F29574    247,646       58,792        58,748

  10.#FFDE65    378,442      330,534       295,506
  11.#F29574    378,442      362,517       335,523

  12.#FBE9A7    531,432      483,461       438,381
  13.#FFDE65    483,461      409,506       438,381
  14.#F29574    531,432      469,493       409,506

  15.#FFDE65    511,484      286,589       286,533
  16.#F29574    511,484      511,540       286,589

  17.#F29574    365,571      311,812       311,583
  18.#FFDE65    365,571      367,758       311,812

  19.#FFDE65    505,584      254,688       254,634
  20.#F29574    505,584      505,638       254,688

  21.#FFDE65    467,550      412,976       412,561
  22.#F29574    467,550      467,923       412,976
  `, 'result'),
}
// console.log(titleText.result)

export default {
  name: 'Cover',
  data: function ()  {
    return {
      // 背景图的位置
      isTx: location.href.indexOf('2021pieces-tx') >= 0,
      bgTop: 0,
      // 内容安全区的位置
      contentTop: 0,
      piecesTop: 0,
      pieces: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21],
      titleText: titleText.default
    }
  },
  components: {
    // HelloWorld
  },
  beforeMount () {
    const windowHeight = window.innerHeight / window.innerWidth * 20
    
    this.piecesTop = ((windowHeight - 24)* 0.65 - 12.5).toFixed(2)

    this.bgTop = (12.5 - (windowHeight - 24) * 12.5/(3248/1500 * 20 - 24)).toFixed(2)
    if (windowHeight - 24 >= 0) {
      this.contentTop = ((windowHeight - 24)* 0.65).toFixed(2)
    }

    if (location.href.indexOf('2021pieces-tx') > 0) {
      this.bg = this.$config.publicPath + 'img/cover/bg@2x-tx.jpg'
    } else {
      this.bg = this.$config.publicPath + 'img/cover/bg@2x.jpg'
    }
  },
  mounted () {
    console.log('cover mounted')
    
    // setTimeout(() => {
    //   this.$emit('nextPage')
    // }, 2000)
    this.initSwiper()

    this.titleText = titleText.result

    setTimeout(() => {
      if (document.querySelector('.finger')) document.querySelector('.finger').classList.add('blink')
    }, 2500)

    if (window._czc) {
      let tagname = ''
      if (location.href.indexOf('/2021pieces-tx') >= 0) {
        tagname += '-tx'
      }
      window._czc.push(['_trackEvent', '2021两会策划' + tagname + '-封面', 'pv', '','',''])
    }
  },
  destroyed () {
    // 页面销毁后
    console.log('destroyed')
    
    // 清空所有定时器
  },
  methods: {
    initSwiper () {
      const swiperConfig = {
        direction: 'vertical',
        // direction: 'horizontal',
        loop: true,
        allowTouchMove : false,
        speed: 600,
        // effect: 'cube',
        // cubeEffect: {
        //   slideShadows: false,
        //   shadow: false
        // }
      }

      this.mySwiper1 = new window.Swiper('#swiper1', swiperConfig)
      this.mySwiper2 = new window.Swiper('#swiper2', swiperConfig)
      this.mySwiper3 = new window.Swiper('#swiper3', swiperConfig)
      this.mySwiper4 = new window.Swiper('#swiper4', swiperConfig)

      this.autoplay()
    },

    autoplay () {
      const delayTime = 0
      const duration = 3600
      const intervalTime = 900

      setTimeout(() => {
        this.mySwiper1.slideNext()

        setInterval(() => {
          const texts = document.querySelectorAll('#swiper1 .swiper-text')
          for (let i = 0 ; i < texts.length; i++) {
            texts[i].style.opacity = 1
          }

          this.mySwiper1.slideNext()
        }, duration)
      }, delayTime + intervalTime * 0)

      setTimeout(() => {
        this.mySwiper2.slideNext()
        
        setInterval(() => {
          const texts = document.querySelectorAll('#swiper2 .swiper-text')
          for (let i = 0 ; i < texts.length; i++) {
            texts[i].style.opacity = 1
          }

          this.mySwiper2.slideNext()
        }, duration)
      }, delayTime + intervalTime * 1)

      setTimeout(() => {
        this.mySwiper3.slideNext()

        setInterval(() => {
          const texts = document.querySelectorAll('#swiper3 .swiper-text')
          for (let i = 0 ; i < texts.length; i++) {
            texts[i].style.opacity = 1
          }

          this.mySwiper3.slideNext()
        }, duration)
      }, delayTime + intervalTime * 2)

      setTimeout(() => {
        this.mySwiper4.slideNext()

        setInterval(() => {
          const texts = document.querySelectorAll('#swiper4 .swiper-text')
          for (let i = 0 ; i < texts.length; i++) {
            texts[i].style.opacity = 1
          }

          this.mySwiper4.slideNext()
        }, duration)
      }, delayTime + intervalTime * 3)
    },
    
    nextPage () {
      this.$emit('nextPage')
    }
  }
}
</script>

<style lang="scss" scoped>
.cover {
  background-color: #ffffff;
  // background-color: rgb(95, 208, 168);
  background-image: url(../assets/cover/bg@2x.jpg);
  background-size: 100% auto;
  background-position: 50% 70%;
  background-repeat: no-repeat;
}
.cover-tx {
  background-image: url(../assets/cover/bg@2x.jpg);
}

.content {
  position: absolute;
  top: 20%;
  left: 0;
  width: 100%;
  height: 24rem;
}
.title {
  position: absolute;
  top: -.2rem;
  left: 2.1867rem;
  width: 15.627rem;
  height: 12.8rem;
  background-image: url(../assets/cover/title@2x.png);
  background-size: 100%;
}

.logo-box {
  display: -webkit-flex;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  position: absolute;
  right: .6rem;
  bottom: .7rem;
  width: 4.35rem;
  height: 3.2rem;
  .logo {
    flex: none;
    width: 4.35rem;
    height: 1.25rem;
    background-image: url(../assets/cover/share_logo.png);
    background-size: 100%;
    background-repeat: no-repeat;
  }
  .logo-tx {
    flex: none;
    margin-top: .5rem;
    width: 4.35rem;
    height: 1.25rem;
    background-image: url(../assets/cover/share_logo_tx.png);
    background-size: 100%;
    background-repeat: no-repeat;
  }

  .logo-china {
    flex: none;
    width: 2.99rem;
    height: 3.2rem;
    background-image: url(../assets/cover/icon@2x.png);
    background-size: 100%;
    background-repeat: no-repeat;
  }
}


/* 背景装饰的动画 */
.anim1 {
  position: absolute;
  top: -2rem;
  left: 1.3333rem;
  width: 2.6133rem;
  height: 3.2533rem;
  background-image: url(../assets/cover/anim1.png);
  background-size: 100%;
}
.anim2 {
  position: absolute;
  top: -7rem;
  left: 3.3333rem;
  width: 1.68rem;
  height: 1.68rem;
  background-image: url(../assets/cover/anim2.png);
  background-size: 100%;
}
.anim3 {
  position: absolute;
  top: -6.6rem;
  left: 15.3333rem;

  width: 2.0267rem;
  height: 1.68rem;
  background-image: url(../assets/cover/anim3.png);
  background-size: 100%;
}
.anim45 {
  position: absolute;
  top: 10rem;
  right: .8rem;
  transform-origin: -2rem 2rem;

  .anim4 {
    position: absolute;
    top: 0;
    right: 0;

    width: 1.3867rem;
    height: 1.1467rem;
    background-image: url(../assets/cover/anim4.png);
    background-size: 100%;
  }
  .anim5 {
    position: absolute;
    top: 1.4rem;
    right: .8rem;

    width: 2.48rem;
    height: 3.3333rem;
    background-image: url(../assets/cover/anim5.png);
    background-size: 100%;
  }
}
.anim6 {
  position: absolute;
  top: 14.4rem;
  left: 9.4rem;

  width: 1.9733rem;
  height: .9333rem;
  background-image: url(../assets/cover/anim6.png);
  background-size: 100%;
}
.anim7 {
  position: absolute;
  top: 19.2rem;
  left: 1.4rem;

  width: 1.6rem;
  height: .9867rem;
  // background-image: url(../assets/cover/anim7.png);
  background-size: 100%;
  .anim7-1 {
    position: absolute;
    top: 0;
    left: 0;

    width: 33.33%;
    height: .9867rem;
    background-image: url(../assets/cover/anim7.png);
    background-size: 1.6rem .9867rem;
    background-position: -2% 50%;
    background-repeat: no-repeat;
  }
  .anim7-2 {
    position: absolute;
    top: 0;
    left: .5333rem;

    width: 33.33%;
    height: .9867rem;
    background-image: url(../assets/cover/anim7.png);
    background-size: 1.6rem .9867rem;
    background-position: 48% 50%;
    background-repeat: no-repeat;
  }
  .anim7-3 {
    position: absolute;
    top: 0;
    left: 1.0667rem;

    width: 33.33%;
    height: .9867rem;
    background-image: url(../assets/cover/anim7.png);
    background-size: 1.6rem .9867rem;
    background-position: 100% 50%;
    background-repeat: no-repeat;
  }
}
.anim8 {
  position: absolute;
  left: -2.8rem;
  bottom: -6.5rem;

  width: 5.2267rem;
  height: 5.2rem;
  background-image: url(../assets/cover/anim8.png);
  background-size: 100%;
}
.anim9 {
  position: absolute;
  left: 5rem;
  bottom: -6rem;

  width: 1.8933rem;
  height: 2.1867rem;
  background-image: url(../assets/cover/anim9.png);
  background-size: 100%;
}
.anim10 {
  position: absolute;
  right: 7.3333rem;
  bottom: -3.5rem;
  
  width: 2.1333rem;
  height: 1.7867rem;
  background-image: url(../assets/cover/anim10.png);
  background-size: 100%;
}
.anim11 {
  position: absolute;
  top: -7.8rem;
  left: -1.5rem;
  
  width: 3.5733rem;
  height: 5.12rem;
  background-image: url(../assets/cover/anim11.png);
  background-size: 100%;
}
.anim12 {
  position: absolute;
  top: -3.1rem;
  right: -.5rem;
  
  width: 3.5733rem;
  height: 1.2rem;
  background-image: url(../assets/cover/anim12.png);
  background-size: 100%;
}

// swiper
.swiper-wrapper{
  // transition-timing-function: linear;
}
#swiper1 {
  position: absolute;
  top: 14.4rem;
  left: 0;

  width: 7.2rem;
	height: 3.3rem;
  /* background-color: rebeccapurple; */
  
  .swiper-text {
    margin: .2rem 1.16rem .2rem;
    text-align: left;
    line-height: 1.6;
    font-family: initial;
    font-weight: 300;
    font-size: .75rem;
    color: rgba(0, 0, 0, 1)
  }
}

#swiper2 {
  position: absolute;
  top: 15.4rem;
  left: 7.2rem;

  width: 12.8rem;
	height: 2.3rem;
  // background-color: rebeccapurple;
  
  .swiper-text {
    margin: .2rem 1.16rem .2rem;
    text-align: center;
    line-height: 1.6;
    font-family: initial;
    font-weight: 300;
    font-size: .75rem;
    color: rgba(0, 0, 0, 1)
  }
}

#swiper3 {
  position: absolute;
  top: 17.7rem;
  left: 3rem;

  width: 10.9rem;
	height: 4.05rem;
  // background-color: rebeccapurple;
  
  .swiper-text {
    margin: .8rem 1.16rem .2rem;
    text-align: left;
    line-height: 1.6;
    font-family: initial;
    font-weight: 300;
    font-size: .75rem;
    color: rgba(0, 0, 0, 1)
  }
}

#swiper4 {
  position: absolute;
  top: 21.8rem;
  left: 0;

  width: 14.4rem;
	height: 3rem;
  // background-color: rebeccapurple;
  
  .swiper-text {
    display: flex;
    display: -webkit-flex;
    justify-content: flex-start;
    align-items: center;

    // margin: 1.125rem 1.16rem 0;
    margin: 0 1.16rem 0;
    height: 100%;
    text-align: left;
    line-height: 1.6;
    font-family: initial;
    font-weight: 300;
    font-size: .75rem;
    color: rgba(0, 0, 0, 1)
  }
}

.finger-box {
  position: absolute;
  top: -.4rem;
  left: 2rem;
  
  width: 15.627rem;
  height: 13rem;

  .finger {
    position: absolute;
    top: 10rem;
    left: 3rem;

    width: 1.8rem;
    height: 2.7rem;

    background-size: 100%;
    background-image: url(../assets/cover/finger.png);
    background-repeat: no-repeat;

    opacity: 0;
  }

  .btn {
    position: absolute;
    top: 5rem;
    left: 1rem;

    width: 6rem;
    height: 9rem;
  }
}

.pieces-pin {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 43.31rem;

  pointer-events: none;

  .piece {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    transition: background-color 1.5s ease-out, clip-path 1s ease-out;
    -webkit-transition: background-color 1.5s ease-out, -webkit-clip-path 1s ease-out;
  }

  $elements: 23;
  @for $i from 0 to $elements {
    .piece:nth-child(#{$i}) {
      transition-delay: $i/22 * 1s, $i/22 * 1s;
    }
  }
}


// 动画
.rotatel {
  animation: rotatel 20s linear infinite;
  -webkit-animation: rotatel 20s linear infinite;
}
@keyframes rotatel {
  0% { transform: rotateZ(0deg); }
  100% { transform: rotateZ(360deg); }
}
@-webkit-keyframes rotatel {
  0% { -webkit-transform: rotateZ(0deg); }
  100% { -webkit-transform: rotateZ(360deg); }
}

.rotater {
  animation: rotater 20s linear infinite;
  -webkit-animation: rotater 20s linear infinite;
}
@keyframes rotater {
  0% { transform: rotateZ(0deg); }
  100% { transform: rotateZ(-360deg); }
}
@-webkit-keyframes rotater {
  0% { -webkit-transform: rotateZ(0deg); }
  100% { -webkit-transform: rotateZ(-360deg); }
}

.rotate45 {
  animation: rotatel 30s linear infinite;
  -webkit-animation: rotatel 30s linear infinite;
}

.fade1 {
  animation: fade 2.4s linear infinite;
  -webkit-animation: fade 2.4s linear infinite;
}
.fade2 {
  animation: fade 2.4s linear .8s infinite;
  -webkit-animation: fade 2.4s linear .8s infinite;
}
.fade3 {
  animation: fade 2.4s linear 1.6s infinite;
  -webkit-animation: fade 2.4s linear 1.6s infinite;
}
@keyframes fade {
  0% {opacity: 0;}
  25% {opacity: 0;}
  50% {opacity: 1;}
  75% {opacity: 1;}
  100% {opacity: 0;}
}
@-webkit-keyframes fade {
  0% {opacity: 0;}
  25% {opacity: 0;}
  50% {opacity: 1;}
  75% {opacity: 1;}
  100% {opacity: 0;}
}

// 闪烁
.blink {
  animation: blink 2s linear both infinite;
  -webkit-animation: blink 2s linear both infinite;
}
@keyframes blink {
  0% { opacity: 0; }
  50% { opacity: 1; }
  100% { opacity: 0; }
}
@-webkit-keyframes blink {
  0% { opacity: 0; }
  50% { opacity: 1; }
  100% { opacity: 0; }
}
</style>
